import { Outlet } from 'react-router'

const WaterTankerLayout = () => {
  return (
    <Outlet />
  )
}

export default WaterTankerLayout
